import {apiTemplate} from "@/core/helpers/api";

export class Feedbacks {
  static async setFeedback(accessToken, action, orderProductUuid, rating) {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "X-SCHON-AUTH": `Bearer ${accessToken}`,
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `mutation {
        feedbackProductAction(action: "${action}", orderProductUuid: "${orderProductUuid}", rating: ${rating}) {
          feedback {
            uuid
          }
        }
      }`
    );

    return await response;
  }
}
